import { useQuery } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import { gqlClient } from '@/lib';
import { createTemplateAccountExperiencesQueryKey } from '@/utils/queryKeys';
import type { GetTemplateAccountExperiencesQuery } from './useTemplateAccountExperiences.generated';

export type TemplateAccountExperience =
  GetTemplateAccountExperiencesQuery['getTemplateAccountExperiences'][number];

const query = gql`
  query GetTemplateAccountExperiences {
    getTemplateAccountExperiences {
      id
      title
      type
      isPublic
      template {
        id
        name
        description
      }
    }
  }
`;

export const useTemplateAccountExperiences = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: createTemplateAccountExperiencesQueryKey(),
    queryFn: () => gqlClient.request<GetTemplateAccountExperiencesQuery>(query),
  });

  return {
    experiences: data?.getTemplateAccountExperiences ?? [],
    isLoading,
    error,
  };
};
